import { BUTTON_SIZE, BUTTON_TYPE, POPOVER_ROLE } from 'consts/enum';
import { generateBtnOnClickFnc, setCustomTagHTML } from 'helpers/helpers';
import { Button } from 'ui/button/button.module';
import { Popover } from 'ui/popover/popover.module';
import { CarouselListTemplate } from './carouselList.template';

export class CarouselList {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initPopover();

		return this.html;
	}

	initData(propData) {
		this.data = {};
		this.setter(propData);
		this.setter({
			headerColor: this.data.header_image ? '#fff' : '#403F42',
		});
	}

	initWrapper() {
		const listWrapper = document.createElement('div');

		listWrapper.classList.add('engt-carousel-list');
		listWrapper.innerHTML = CarouselListTemplate(this.data);

		this.html = listWrapper;
	}

	initComponents = () => {
		const { headerBtns, footerBtns, parentHTML, carouselId } = this.data;

		if (headerBtns?.length) {
			const fragment = document.createDocumentFragment();

			headerBtns.map((btn) => {
				fragment.appendChild(
					new Button({
						type: BUTTON_TYPE.BASE,
						size: BUTTON_SIZE.SMALL,
						label: btn.title,
						applyOnHover: true,
						onClick: generateBtnOnClickFnc(btn),
						style: 'width: calc( 100% - 16px); margin: 4px 8px 0 8px;',
					}).render()
				);
			});

			setCustomTagHTML(this.html.querySelector('header-button'), fragment);
		} else {
			setCustomTagHTML(this.html.querySelector('header-button'), '');
		}

		setCustomTagHTML(this.html.querySelector('list-cards'), parentHTML.querySelector(`#${carouselId}`));

		if (footerBtns?.length) {
			const fragment = document.createDocumentFragment();

			footerBtns.map((btn) => {
				fragment.appendChild(
					new Button({
						type: BUTTON_TYPE.PRIMARY,
						size: BUTTON_SIZE.SMALL,
						label: btn.title,
						applyOnHover: true,
						onClick: generateBtnOnClickFnc(btn),
						style: 'border-radius: 0 0 8px 8px;padding: 10px 8px 10px 8px;',
					}).render()
				);
			});

			this.html.appendChild(fragment);
		}
	};

	initPopover = () => {
		const ref = this;
		const titleDiv = this.html.querySelector('.title');
		const descriptionDiv = this.html.querySelector('.sub-title');
		const parent = titleDiv?.parentNode || descriptionDiv?.parentNode;

		if (descriptionDiv) {
			new Popover({
				parent: descriptionDiv,
				child: descriptionDiv.cloneNode(true),
				role: POPOVER_ROLE.EXPANDABLE,
				onClick() {
					if (parent) {
						parent.style.height = `${
							parent.clientHeight + descriptionDiv.scrollHeight - descriptionDiv.clientHeight
						}px`;
						descriptionDiv.style.height = 'unset';
					}
				},
			}).render();
		}
		if (titleDiv) {
			new Popover({
				parent: titleDiv,
				child: titleDiv.cloneNode(true),
				role: POPOVER_ROLE.EXPANDABLE,
				onClick() {
					if (parent) {
						parent.style.height = `${
							parent.clientHeight + titleDiv.scrollHeight - titleDiv.clientHeight
						}px`;
						titleDiv.style.height = 'unset';
					}
				},
			}).render();
		}
	};

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
